import { httpCreate } from './http';

const http = httpCreate('/shop/api/phy-agent');

export const phyAgent = {
	getNameList(params) {
		return http.get('/nameList', { params });
	},
	preheatNameList(params) {
		return http.get('/preheat/nameList', { params });
	},
};
